import { SubscriptionDuration, SubscriptionType, subscriptionTypeTitle } from './plan.types';

export enum NotificationType {
  ACTIVITY = 'activity',
  REQUEST = 'request',
}

export const notificationTypeMap = Object.values(NotificationType);

export enum NotificationAction {
  ENTERPRISE_REQUEST = 'enterprise-request',
  STAKEHOLDER_LIMIT_REACHED = 'stakeholder-limit-reached',
  SUBSCRIPTION_CHANGE = 'company-upgrade',
}

export const notificationActionTitle: Record<NotificationAction, string> = {
  [NotificationAction.ENTERPRISE_REQUEST]: 'New enterprise request',
  [NotificationAction.SUBSCRIPTION_CHANGE]: 'Subscription Change',
  [NotificationAction.STAKEHOLDER_LIMIT_REACHED]: 'Stakeholder Threshold Reached',
};

export type NotificationAdminsRead = {
  adminId: string;
  id: string;
  notification: Notification;
  notificationId: string;
  stakeholderId: string;
};

export type AppNotification = {
  action?: NotificationAction;
  adminEmail?: string;
  companyId: string;
  companyName: string;
  createdAt: Date;
  currentFrequency?: SubscriptionDuration;
  currentType?: SubscriptionType;
  id: string;
  is_read: boolean;
  notificationAdminsRead: NotificationAdminsRead[];
  prevSubscriptionFreq?: SubscriptionDuration;
  prevSubscriptionType?: SubscriptionType;
  resolved: boolean;
  stakeholderLimit?: number;
  type: NotificationType;
};

type ActiveNotificationBaseOptions = {
  action: NotificationAction;
  companyName: string;
  currentFrequency: SubscriptionDuration;
  currentType: SubscriptionType;
  prevSubscriptionFreq: SubscriptionDuration;
  prevSubscriptionType: SubscriptionType;
  stakeholderLimit: number;
};

type RequestNotificationBaseOptions = {
  companyName: string;
};

const createCompanyUpgradeNotification = (options: ActiveNotificationBaseOptions) =>
  `${options.companyName} - Subscription plan changed from ${subscriptionTypeTitle[options.prevSubscriptionType]} (${options.prevSubscriptionFreq}) to ${subscriptionTypeTitle[options.currentType]} (${options.currentFrequency})`;

const createStakeholderLimitReachedNotification = (options: ActiveNotificationBaseOptions) =>
  `${options.companyName} (${subscriptionTypeTitle[options.currentType]}) has reached it stakeholder threshold limit (${options.stakeholderLimit})`;

const createEEnterpriseRequestNotification = (options: RequestNotificationBaseOptions) =>
  `New enterprise request by ${options.companyName}`;

const NotificationFactory = {
  createActionNotification: (options: ActiveNotificationBaseOptions) => {
    switch (options.action) {
      case NotificationAction.STAKEHOLDER_LIMIT_REACHED:
        return createStakeholderLimitReachedNotification(options);
      case NotificationAction.SUBSCRIPTION_CHANGE:
        return createCompanyUpgradeNotification(options);
      default:
        return createCompanyUpgradeNotification(options);
    }
  },

  createRequestNotification: (options: RequestNotificationBaseOptions) => {
    return createEEnterpriseRequestNotification(options);
  },
};

export const activityNotificationBuilder = NotificationFactory.createActionNotification;
export const requestNotificationBuilder = NotificationFactory.createRequestNotification;
